// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from "flatbuffers";

/**
 * Queue/buffer diagnostics.
 */
export class BufferSnapshot implements flatbuffers.IUnpackableObject<BufferSnapshotT> {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): BufferSnapshot {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  static getRootAsBufferSnapshot(bb: flatbuffers.ByteBuffer, obj?: BufferSnapshot): BufferSnapshot {
    return (obj || new BufferSnapshot()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  static getSizePrefixedRootAsBufferSnapshot(
    bb: flatbuffers.ByteBuffer,
    obj?: BufferSnapshot,
  ): BufferSnapshot {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
    return (obj || new BufferSnapshot()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  queueDepth(): number {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset ? this.bb!.readUint32(this.bb_pos + offset) : 0;
  }

  maxCapacity(): number {
    const offset = this.bb!.__offset(this.bb_pos, 6);
    return offset ? this.bb!.readUint32(this.bb_pos + offset) : 0;
  }

  evictionCount(): number {
    const offset = this.bb!.__offset(this.bb_pos, 8);
    return offset ? this.bb!.readUint32(this.bb_pos + offset) : 0;
  }

  bufferBytes(): bigint {
    const offset = this.bb!.__offset(this.bb_pos, 10);
    return offset ? this.bb!.readUint64(this.bb_pos + offset) : 0n;
  }

  static startBufferSnapshot(builder: flatbuffers.Builder) {
    builder.startObject(4);
  }

  static addQueueDepth(builder: flatbuffers.Builder, queueDepth: number) {
    builder.addFieldInt32(0, queueDepth, 0);
  }

  static addMaxCapacity(builder: flatbuffers.Builder, maxCapacity: number) {
    builder.addFieldInt32(1, maxCapacity, 0);
  }

  static addEvictionCount(builder: flatbuffers.Builder, evictionCount: number) {
    builder.addFieldInt32(2, evictionCount, 0);
  }

  static addBufferBytes(builder: flatbuffers.Builder, bufferBytes: bigint) {
    builder.addFieldInt64(3, bufferBytes, 0n);
  }

  static endBufferSnapshot(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject();
    return offset;
  }

  static createBufferSnapshot(
    builder: flatbuffers.Builder,
    queueDepth: number,
    maxCapacity: number,
    evictionCount: number,
    bufferBytes: bigint,
  ): flatbuffers.Offset {
    BufferSnapshot.startBufferSnapshot(builder);
    BufferSnapshot.addQueueDepth(builder, queueDepth);
    BufferSnapshot.addMaxCapacity(builder, maxCapacity);
    BufferSnapshot.addEvictionCount(builder, evictionCount);
    BufferSnapshot.addBufferBytes(builder, bufferBytes);
    return BufferSnapshot.endBufferSnapshot(builder);
  }

  unpack(): BufferSnapshotT {
    return new BufferSnapshotT(
      this.queueDepth(),
      this.maxCapacity(),
      this.evictionCount(),
      this.bufferBytes(),
    );
  }

  unpackTo(_o: BufferSnapshotT): void {
    _o.queueDepth = this.queueDepth();
    _o.maxCapacity = this.maxCapacity();
    _o.evictionCount = this.evictionCount();
    _o.bufferBytes = this.bufferBytes();
  }

  unpackFields(...fields: string[]): BufferSnapshotT {
    const t = new BufferSnapshotT();
    const fieldSet = new Set(fields);
    if (fieldSet.has("queue_depth")) {
      t.queueDepth = this.queueDepth();
    }
    if (fieldSet.has("max_capacity")) {
      t.maxCapacity = this.maxCapacity();
    }
    if (fieldSet.has("eviction_count")) {
      t.evictionCount = this.evictionCount();
    }
    if (fieldSet.has("buffer_bytes")) {
      t.bufferBytes = this.bufferBytes();
    }
    return t;
  }
}

export class BufferSnapshotT implements flatbuffers.IGeneratedObject {
  constructor(
    public queueDepth: number = 0,
    public maxCapacity: number = 0,
    public evictionCount: number = 0,
    public bufferBytes: bigint = 0n,
  ) {}

  pack(builder: flatbuffers.Builder): flatbuffers.Offset {
    return BufferSnapshot.createBufferSnapshot(
      builder,
      this.queueDepth,
      this.maxCapacity,
      this.evictionCount,
      this.bufferBytes,
    );
  }

  clone(): BufferSnapshotT {
    const obj = new BufferSnapshotT();
    obj.queueDepth = this.queueDepth;
    obj.maxCapacity = this.maxCapacity;
    obj.evictionCount = this.evictionCount;
    obj.bufferBytes = this.bufferBytes;
    return obj;
  }

  equals(other: BufferSnapshotT): boolean {
    if (this.queueDepth !== other.queueDepth) return false;
    if (this.maxCapacity !== other.maxCapacity) return false;
    if (this.evictionCount !== other.evictionCount) return false;
    if (this.bufferBytes !== other.bufferBytes) return false;
    return true;
  }
}

export function verifyBufferSnapshot(verifier: flatbuffers.Verifier, tablePos: number): void {
  verifier.checkTable(tablePos);
  try {
    verifier.checkScalarField(tablePos, 4, 4);
    verifier.checkScalarField(tablePos, 6, 4);
    verifier.checkScalarField(tablePos, 8, 4);
    verifier.checkScalarField(tablePos, 10, 8);
  } finally {
    verifier.popDepth();
  }
}
